import { ContainerModule } from 'inversify';
import { DslRuntimeSymbol, DslRuntime, ModularizedRuntime,
         DslRuntimeModule, DslRuntimeModuleSymbol, SystemDslModule } from '@xlearn/common';

export const dslRuntimeModule = new ContainerModule((bind) => {
  bind<DslRuntimeModule>(DslRuntimeModuleSymbol).to(SystemDslModule);
  bind<DslRuntime>(DslRuntimeSymbol).to(ModularizedRuntime).inSingletonScope();
});
